import React from 'react'

const PageLink = ({link}) => {
  return (
    <>
      <li className='links-items text-sm sm:text-bs md:text-lg'>
          <a href ={link.href} className = "font-face-tkup"> {link.text} </a> 
      </li> 
    </>
  )
}

export default PageLink